/* ============================================================
   VINUSTORE CUSTOM LAYER — behavior
   ============================================================ */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 0. Auto-tag existing Trade sections for reveal ---------- */
  function initAutoTag() {
    if (reducedMotion) return;
    var fold = window.innerHeight * 0.85;
    var groupSelectors = [
      '.multicolumn-list',
      '.collection-list',
      'ul.product-grid',
      '.blog__posts'
    ];
    var singleSelectors = [
      '.rich-text__wrapper',
      '.title-wrapper-with-link',
      '.image-banner .banner__box'
    ];
    groupSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.getBoundingClientRect().top > fold) {
          el.setAttribute('data-vs-reveal-group', '');
        }
      });
    });
    singleSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[data-vs-reveal-group]')) return;
        if (el.getBoundingClientRect().top > fold) {
          el.setAttribute('data-vs-reveal', '');
        }
      });
    });
  }

  /* ---------- 1. Scroll-reveal (single + group stagger) ---------- */
  function initReveal() {
    var singles = document.querySelectorAll('[data-vs-reveal]');
    var groups = document.querySelectorAll('[data-vs-reveal-group]');
    if (reducedMotion || !('IntersectionObserver' in window)) {
      singles.forEach(function (el) { el.classList.add('vs-in'); });
      groups.forEach(function (el) { el.classList.add('vs-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.hasAttribute('data-vs-reveal-group')) {
          Array.prototype.forEach.call(el.children, function (child, i) {
            child.style.setProperty('--vs-delay', Math.min(i * 90, 540) + 'ms');
          });
        }
        el.classList.add('vs-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    singles.forEach(function (el) { io.observe(el); });
    groups.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Sticky header scroll effect ---------- */
  function initHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('vs-header-scrolled', window.scrollY > 80);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- 3. Stat counters ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-vs-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseInt(el.getAttribute('data-vs-count'), 10) || 0;
      var suffix = el.getAttribute('data-vs-suffix') || '';
      if (reducedMotion) { el.textContent = target.toLocaleString() + suffix; return; }
      var start = null, DUR = 1200;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / DUR, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 4. Add-to-cart: morph + fly-dot + badge pop ---------- */
  function flyToCart(fromEl) {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon || reducedMotion) return;
    var a = fromEl.getBoundingClientRect();
    var b = cartIcon.getBoundingClientRect();
    var dot = document.createElement('span');
    dot.className = 'vs-fly-dot';
    dot.style.left = (a.left + a.width / 2) + 'px';
    dot.style.top = (a.top + a.height / 2) + 'px';
    document.body.appendChild(dot);
    requestAnimationFrame(function () {
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
      var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      dot.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.4)';
      dot.style.opacity = '0';
    });
    setTimeout(function () {
      dot.remove();
      var badge = document.querySelector('.cart-count-bubble');
      if (badge) {
        badge.classList.remove('vs-pop');
        void badge.offsetWidth;
        badge.classList.add('vs-pop');
      }
    }, 660);
  }

  function morphButton(btn) {
    var label = btn.querySelector('span') || btn;
    var original = label.textContent;
    btn.classList.add('vs-added');
    label.textContent = '✓ Added';
    setTimeout(function () {
      btn.classList.remove('vs-added');
      label.textContent = original;
    }, 1800);
  }

  function initAtc() {
    var lastBtn = null;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="add"]');
      if (btn) lastBtn = btn;
    }, true);

    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function () {
        if (lastBtn) { morphButton(lastBtn); flyToCart(lastBtn); lastBtn = null; }
      });
    } else {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('button[name="add"]');
        if (!btn) return;
        setTimeout(function () {
          if (!btn.getAttribute('aria-disabled')) { morphButton(btn); flyToCart(btn); }
        }, 900);
      });
    }
  }

  /* ---------- 5. Charge bar (free-shipping progress) ---------- */
  function updateChargeBars() {
    var bars = document.querySelectorAll('.vs-charge-bar[data-vs-threshold]');
    if (!bars.length) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bars.forEach(function (bar) {
          var threshold = parseInt(bar.getAttribute('data-vs-threshold'), 10);
          var ratio = Math.min(cart.total_price / threshold, 1);
          bar.style.setProperty('--vs-charge', ratio);
          var msg = bar.parentElement.querySelector('.vs-charge-msg');
          if (msg) {
            if (ratio >= 1) {
              msg.textContent = '⚡ FREE shipping unlocked!';
            } else {
              var remain = ((threshold - cart.total_price) / 100).toFixed(2);
              msg.textContent = 'RM' + remain + ' more to unlock FREE shipping ⚡';
            }
          }
        });
      })
      .catch(function () { /* silent */ });
  }
  function initChargeBar() {
    updateChargeBars();
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', updateChargeBars);
    }
  }

  /* ---------- boot ---------- */
  function boot() {
    initAutoTag();
    initReveal();
    initHeader();
    initCounters();
    initAtc();
    initChargeBar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
